const actions = {
    setObjUsuario({ commit }, value) {
        commit("SET_OBJ_USUARIO", value);
    }
}

export default actions;
